/**
 * Projects
 */
// Web
import Bmi from "../assets/img/projects/bmi.png";
import CyberId from "../assets/img/projects/cyberid.png";
import Konversi from "../assets/img/projects/konversi.png";
import Qiraa from "../assets/img/projects/qiraa.png";
import TravelokaOcr from "../assets/img/projects/travelokaocr.png";
// import MentoringgProject from "../assets/img/projects/mentoringg.png";
import Laracamp from "../assets/img/projects/laracamp.png";

// API
import OpenMusicAPI from "../assets/img/projects/openmusicapi.png";
import MangementBookAPI from "../assets/img/projects/managementbookapi.png";

// Mobile
import Reseppin from "../assets/img/projects/reseppin.png";

// UI
import Bimbel from "../assets/img/projects/bimbel.png";
import Coffee from "../assets/img/projects/coffee.png";
import Tumbas from "../assets/img/projects/tumbas.png";

/**
 * Certificates
 */
// Academic
import ACP from "../assets/img/certificates/accp.jpg";
import DTSAWS from "../assets/img/certificates/dtsaws.png";
import Bangkit from "../assets/img/certificates/bangkit.jpg";
import Backend from "../assets/img/certificates/aplikasibackend.png";
import Javascript from "../assets/img/certificates/belajarjavascript.png";
import Cloud from "../assets/img/certificates/cloudpractitioner.png";
import Web from "../assets/img/certificates/pemrogramanweb.jpg";

// Works
import Telkom from "../assets/img/certificates/telkom.png";
import Alpro from "../assets/img/certificates/alpro.jpg";
import Pbo from "../assets/img/certificates/pbo.jpg";
import Mentoringg from "../assets/img/certificates/mentoringg.png";

// Volunteers
import Cpns from "../assets/img/certificates/cpns.png";
import TelRun from "../assets/img/certificates/telrun.png";
import OpenMindCCI from "../assets/img/certificates/openmindcci.png";

// Achievements
import Itcc from "../assets/img/certificates/itcc.png";
import Itechnocup from "../assets/img/certificates/itechnocup.png";
import Posi from "../assets/img/certificates/posi.png";

const tabProject = [
	{
		title: "Website",
		tabLink: "website",
	},
	{
		title: "Mobile",
		tabLink: "mobile",
	},
	{
		title: "APIs",
		tabLink: "api",
	},
	{
		title: "UI/UX",
		tabLink: "uiux",
	},
];
const tabCertificates = [
	{
		title: "Academics",
		tabLink: "academics",
	},
	{
		title: "Achievements",
		tabLink: "achievements",
	},
	{
		title: "Works",
		tabLink: "works",
	},
	{
		title: "Volunteers",
		tabLink: "volunteers",
	},
];

const projects = [
	{
		title: "TravelokaOCR",
		image: TravelokaOcr,
		technology: "Bootstrap, AOS, & Jquery",
		category: "website",
		icons: {
			web: "mdi:web",
			github: "mdi:github",
		},
		links: {
			web: "https://capstone-bangkit-c22-ky01.github.io/traveloka-ocr-landingpage/",
			github: "https://github.com/capstone-bangkit-c22-ky01/traveloka-ocr-landingpage",
		},
	},
	{
		title: "Laracamp",
		image: Laracamp,
		technology: "Laravel, Tailwind, Midtrans API, & MySql",
		category: "website",
		icons: {
			github: "mdi:github",
		},
		links: {
			github: "https://github.com/mfaisalh12/laracamp",
		},
	},
	{
		title: "CyberID Community",
		image: CyberId,
		technology: "HTML, CSS, & Javascript",
		category: "website",
		icons: {
			web: "mdi:web",
			github: "mdi:github",
		},
		links: {
			web: "https://mfaisalh12.github.io/cyberid_community/",
			github: "https://github.com/mfaisalh12/cyberid_community",
		},
	},
	{
		title: "Number Conversion",
		image: Konversi,
		technology: "HTML, CSS, & Javascript",
		category: "website",
		icons: {
			web: "mdi:web",
			github: "mdi:github",
		},
		links: {
			web: "https://mfaisalh12.github.io/number-conversion/",
			github: "",
		},
	},
	{
		title: "Qira'a",
		image: Qiraa,
		technology: "Bootstrap & Javascript",
		category: "website",
		icons: {
			web: "mdi:web",
			github: "mdi:github",
		},
		links: {
			web: "https://mfaisalh12.github.io/qiraa/",
			github: "https://github.com/mfaisalh12/qiraa",
		},
	},
	{
		title: "BMI Calculator",
		image: Bmi,
		technology: "Bootstrap & Javascript",
		category: "website",
		icons: {
			web: "mdi:web",
			github: "mdi:github",
		},
		links: {
			web: "https://mfaisalh12.github.io/bmi-calculator-frontend/",
			github: "",
		},
	},
	{
		title: "Reseppin",
		image: Reseppin,
		technology: "React Native & Spoonacular API",
		category: "mobile",
		icons: {
			github: "mdi:github",
		},
		links: {
			github: "https://github.com/mfaisalh12/cooking-recipe-app",
		},
	},
	{
		title: "Open Music API v3",
		image: OpenMusicAPI,
		technology: "NodeJs, HapiJs, & Redis",
		category: "api",
		icons: {
			github: "mdi:github",
		},
		links: {
			github: "https://github.com/mfaisalh12/open-music-api/tree/v3",
		},
	},
	{
		title: "Management Book Store API",
		image: MangementBookAPI,
		technology: "NodeJs, Express, MySQL, & Sequelize",
		category: "api",
		icons: {
			github: "mdi:github",
		},
		links: {
			github: "https://github.com/mfaisalh12/management-store-api",
		},
	},
	{
		title: "Tumbass",
		image: Tumbas,
		technology: "Figma",
		category: "uiux",
		icons: {
			figma: "ph:figma-logo-fill",
		},
		links: {
			figma: "",
		},
	},
	{
		title: "Bimbel Online",
		image: Bimbel,
		technology: "Figma",
		category: "uiux",
		icons: {
			figma: "ph:figma-logo-fill",
		},
		links: {
			figma: "",
		},
	},
	{
		title: "Coffee Shop",
		image: Coffee,
		technology: "Figma",
		category: "uiux",
		icons: {
			figma: "",
		},
		links: {
			figma: "",
		},
	},
];

const certificates = [
	{
		title: "AWS Cloud Practitioner",
		publisher: "Amazon Web Services",
		image: ACP,
		category: "academics",
		startDate: "May 2023",
		endDate: "May 2026",
		link: "#",
	},
	{
		title: "Cloud Developing",
		publisher: "Digital Talent Scholarship (Kominfo)",
		image: DTSAWS,
		category: "academics",
		startDate: "Sep 2022",
		endDate: "Oct 2022",
		link: "#",
	},
	{
		title: "Cloud Computing Learning Path",
		publisher: "Bangkit Academy 2022",
		image: Bangkit,
		category: "academics",
		startDate: "Feb 2022",
		endDate: "Jul 2022",
		link: "#",
	},
	{
		title: "Belajar Membuat Aplikasi Back-End",
		publisher: "Dicoding Indonesia",
		image: Backend,
		category: "academics",
		startDate: "Jun 2021",
		endDate: "Jun 2024",
		link: "#",
	},
	{
		title: "Belajar Dasar Pemrograman JavaScript",
		publisher: "Dicoding Indonesia",
		image: Javascript,
		startDate: "Mei 2022",
		endDate: "Mei 2024",
		category: "academics",
		link: "#",
	},
	{
		title: "Cloud Practicioner Essentials",
		publisher: "Dicoding Indonesia",
		image: Cloud,
		startDate: "Apr 2021",
		endDate: "Apr 2024",
		category: "academics",
		link: "#",
	},
	{
		title: "Belajar Dasar Pemrograman Web",
		publisher: "Dicoding Indonesia",
		image: Web,
		startDate: "Nov 2020",
		endDate: "Nov 2022",
		category: "academics",
		link: "#",
	},
	{
		title: "Back-End Developer Intern",
		publisher: "Digital Amoeba (Corporate Lab by Telkom Indonesia)",
		image: Telkom,
		startDate: "Aug 2022",
		endDate: "Dec 2022",
		category: "works",
		link: "#",
	},
	{
		title: "Asisten Lab Algoritma & Pemrograman",
		publisher: "Software Engineering Application (SEA) Lab",
		image: Alpro,
		startDate: "Jan 2022",
		endDate: "Jun 2022",
		category: "works",
		link: "#",
	},
	{
		title: "Asisten Lab Pemrograman Berorientasi Objek",
		publisher: "Software Engineering Application (SEA) Lab",
		image: Pbo,
		startDate: "Aug 2021",
		endDate: "Jan 2022",
		category: "works",
		link: "#",
	},
	{
		title: "Web Developer Intern",
		publisher: "Mentoringg.id",
		image: Mentoringg,
		startDate: "Jul 2021",
		endDate: "Dec 2021",
		category: "works",
		link: "#",
	},
	{
		title: "Anggota Divisi Acara",
		publisher: "Competitive Programming Netizen SEA 1.0",
		image: Cpns,
		startDate: "Feb 2022",
		endDate: "Jul 2022",
		category: "volunteers",
		link: "#",
	},
	{
		title: "Anggota Divisi Ticketing",
		publisher: "Telkom University Run 2021",
		image: TelRun,
		startDate: "Aug 2021",
		endDate: "Oct 2021",
		category: "volunteers",
		link: "#",
	},
	{
		title: "Anggota Divisi Media & Dokumentasi",
		publisher: "Open Mind UKM CCI 2020",
		image: OpenMindCCI,
		startDate: "Sep 2020",
		endDate: "Oct 2020",
		category: "volunteers",
		link: "#",
	},
	{
		title: "1st Winner of Web Design",
		publisher: "Information Technology Creative Competition 2021",
		image: Itcc,
		startDate: "Nov 2021",
		endDate: "Nov 2021",
		category: "achievements",
		link: "#",
	},
	{
		title: "1st Winner of Web Design",
		publisher: "Itechno Cup Competition 2021",
		image: Itechnocup,
		startDate: "Jul 2021",
		endDate: "Aug 2021",
		category: "achievements",
		link: "#",
	},
	{
		title: "Silver Medal Winner",
		publisher: "Kompetisi Sains Indonesia (KSI) POSI 2021",
		image: Posi,
		startDate: "Feb 2021",
		endDate: "Feb 2021",
		category: "achievements",
		link: "#",
	},
];

export { tabProject, tabCertificates, projects, certificates };
